import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';

import { Subscription } from 'rxjs';

import { ShiftSchedule } from 'src/shared/models/shift-schedule.model';
import { ShiftScheduleService } from 'src/shared/services/shift-schedule.service';
import { StaffingGridConstants } from '../utilities/staffing-grid-constants.util';
import { StartHour } from '../models/start-hour.model';

@Component({
    selector: 'smt-shiftblock-input',
    templateUrl: './shiftblock-input.component.html',
    styleUrls: ['./shiftblock-input.component.scss']
})
export class ShiftBlockInputComponent implements OnChanges, OnDestroy {
    @Input() startHour: number = null;
    @Input() blockSize: number = null;
    @Output() startHourChanged = new EventEmitter();

    shiftBlockSizes: number[] = [ 1, 2, 3, 4, 6, 8, 12, 24 ];
    shiftBlockStartHours: StartHour[] = [
        { description: '', hour: null },
        { description: '12am', hour: 0 },
        { description: '1am', hour: 1 },
        { description: '2am', hour: 2 },
        { description: '3am', hour: 3 },
        { description: '4am', hour: 4 },
        { description: '5am', hour: 5 },
        { description: '6am', hour: 6 },
        { description: '7am', hour: 7 },
        { description: '8am', hour: 8 },
        { description: '9am', hour: 9 },
        { description: '10am', hour: 10 },
        { description: '11am', hour: 11 },
        { description: '12pm', hour: 12 },
        { description: '1pm', hour: 13 },
        { description: '2pm', hour: 14 },
        { description: '3pm', hour: 15 },
        { description: '4pm', hour: 16 },
        { description: '5pm', hour: 17 },
        { description: '6pm', hour: 18 },
        { description: '7pm', hour: 19 },
        { description: '8pm', hour: 20 },
        { description: '9pm', hour: 21 },
        { description: '10pm', hour: 22 },
        { description: '11pm', hour: 23 },
    ];

    selectedShiftBlockHour: number = null;
    selectedShiftBlockSize: number;

    private schedules: ShiftSchedule[] = [];
    private scheduleSubscription: Subscription;

    constructor(private _shiftScheduleService: ShiftScheduleService) { 
        this.scheduleSubscription = this._shiftScheduleService.schedules$.subscribe((schedules) => {
            this.schedules = schedules;
        });
    }

    ngOnChanges() {
        this.setValues();
    }

    ngOnDestroy() {
        if (this.scheduleSubscription) {
            this.scheduleSubscription.unsubscribe();
        }
    }

    blockSizeSaved(): boolean {
        return this.schedules.some(s => !!s.id);
    }

    setValues() {
        if (this.startHour == null || this.startHour >= 0) {
            this.selectedShiftBlockHour = this.startHour;
        }    
        else {
            this.selectedShiftBlockHour = this.shiftBlockStartHours[0].hour;
        }
        
        if (this.blockSize) {
            this.selectedShiftBlockSize = this.blockSize;
        }
        else {
            this.selectedShiftBlockSize = StaffingGridConstants.DefaultShiftBlockLength;
        }
    }

    onChangeStartHour() {
        this.startHourChanged.emit(this.selectedShiftBlockHour);
    }
}
